import {DiaryRecipeProductViewModel} from '../viewModels/diaryRecipeProduct.viewModel';

export const sum_products_weight = (products: any[], productCalculationsByProductId): number => {
    let weight = 0;

    // tslint:disable-next-line:forin
    for (const i in products) {
        const calc = productCalculationsByProductId[products[i]['id']];

        weight += Math.round(Math.round(calc['weight']) * Math.round(calc['qty']));
    }

    return weight;
};


export const sum_diary_products_weight = (diaryProducts: DiaryRecipeProductViewModel[]): number => {
    let weight = 0;

    // tslint:disable-next-line:forin
    for (const i in diaryProducts) {
        // tslint:disable-next-line:radix
        weight += Math.round(Math.round(parseFloat(diaryProducts[i]['weight'])) * Math.round((diaryProducts[i]['qty'])));
    }

    return weight;
};
